export const enum TransitionDirection {
  Left = 1,
  None = 0,
  Right = -1,
}
